import { inject, Injectable, Signal } from '@angular/core';
import { UserAccount, UserPreferences } from '@iot-platform/models/common';
import { Store } from '@ngrx/store';
import { PreferencesActions } from '../actions';
import * as fromUsers from '../reducers';

@Injectable({
  providedIn: 'root'
})
export class PreferencesFacade {
  private readonly store: Store = inject(Store);

  currentUser: Signal<UserAccount> = this.store.selectSignal(fromUsers.getCurrentPreferencesUser);
  preferences: Signal<UserPreferences> = this.store.selectSignal(fromUsers.getPreferences);

  updateUserPreferences(preferences: UserPreferences) {
    this.store.dispatch(PreferencesActions.saveUserPreferences({ preferences }));
  }

  setLanguage(lang: string) {
    this.store.dispatch(PreferencesActions.changeLanguage({ lang }));
  }
}
